module.exports = __webpack_public_path__ + "static/searchenginemarketing-ca868d5236e5b272729377b654e0082d.jpeg";